<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.0002" cy="12.8" r="0.8" fill="#0054A6"/>
    <path d="M8 7.2L8 10.4" stroke="#0054A6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.44721 13.1056L6.21115 3.57771C6.94819 2.10361 9.05181 2.10361 9.78885 3.57771L14.5528 13.1056C15.2177 14.4354 14.2507 16 12.7639 16H3.23607C1.7493 16 0.782312 14.4354 1.44721 13.1056Z" stroke="#0054A6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
  
<script>
  export default {
    name: 'SvgAlert'
  }
</script>